<template>
  <div class="recharge">
    <Nav :title="$t('newAdd.recharge')" fixed safeAreaInsetTop placeholder />
    <div class="content-wrap">
      <div class="padding16">
        <div class="content white-back">
          <div class="payNum font12">
            {{ $t("newAdd.amount") }}：
            <span class="color-red font22">{{ payData.money }}</span>
          </div>
          <div class="top6 flex between width100pre center-ver">
            <div class="font14 address-wrap">
              {{ $t("bankName") }}:
              <span class="font12">{{ payData.setting.open }}</span>
            </div>
            <div class="copy" @click="copy('open')">
              {{ $t("newAdd.copy") }}
            </div>
          </div>
          <div class="top6 flex between width100pre center-ver">
            <div class="font14 address-wrap">
              {{ $t("newAdd.payee") }}:
              <span class="font12">{{ payData.setting.name }}</span>
            </div>
            <div class="copy" @click="copy('name')">
              {{ $t("newAdd.copy") }}
            </div>
          </div>
          <div class="top6 flex between width100pre center-ver">
            <div class="font14 address-wrap">
              {{ $t("bankCard") }}:
              <span class="font12">{{ payData.setting.card }}</span>
            </div>
            <div class="copy" @click="copy('card')">
              {{ $t("newAdd.copy") }}
            </div>
          </div>
        </div>
        <div class="step-wrap top16">
          <div class="font14">{{ $t("newAdd.rechargeSteps") }}：</div>
          <div class="font12 line1 top10">
            <div v-for="(item, index) in steps" :key="index">
              {{ index + 1 }}.{{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed btn-wrap flex">
      <div class="left" style="width: 100%" @click="confirm">
        {{ $t("newAdd.completePayment") }}
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Image as VanImage, Toast } from "vant";
import download from "downloadjs";
import { RECHARGE_COMMIT } from "@/api";
import Nav from "@/components/Navbar";
export default {
  components: {
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    Toast,
    Nav
  },
  data() {
    return {
      payData: {},
      steps: [],
    };
  },
  methods: {
    downloadQr() {
      this.$router.back();
    },
    copy(which) {
      this.$copyText(this.payData.setting[which]).then((e) => {
        Toast("Copy successfully");
      });
    },
    confirm() {
      RECHARGE_COMMIT({
        id: this.payData.id,
        money: this.payData.money,
        account: this.payData.account,
        isbefore: 1,
      }).then(res => {
        Toast.clear();
        if (res.ret === 3) {
          Toast.clear();
          this.$router.back();
        } else {
          Toast(res.msg);
        }
      }).catch((e) => { });
    },
  },
  created() {
    let payData = this.$route.params.payData;
    if (payData) {
      this.payData = payData;
      this.$cookie.set("qrPayData", JSON.stringify(this.payData));
    } else {
      this.payData = JSON.parse(this.$cookie.get("qrPayData"));
    }
    this.steps = this.payData.step.split(/[0-9]./);
    for (let i = 0; i < this.steps.length; i++) {
      let item = this.steps[i];
      if (item == "") {
        this.steps.splice(i, 1);
      }
    }
  },
  mounted() { },
  destroyed() {
    // this.$cookie.remove("qrPayData");
  },
};
</script>

<style lang="less" scoped>
.recharge {
  position: relative;
  min-height: 100vh;
  background: var(--bgImg) no-repeat;
  background-size: 100% 100%;

  .content-wrap {
    position: relative;
    overflow: hidden;

    .content {
      padding: calc(16rem / 16);
      border-radius: 10px;
    }
  }
}
</style>

<style scoped>
.top10 {
  margin-top: 0.625rem;
}

.top6 {
  margin-top: 0.375rem;
}

.top16 {
  margin-top: 1rem;
}

.padding16 {
  padding: 1rem;
}

.padding10 {
  padding: 0.625rem;
}

.white-back {
  background-color: #fff;
}

.font12 {
  font-size: 0.75rem;
}

.font14 {
  font-size: 0.875rem;
}

.font16 {
  font-size: 1rem;
}

.font18 {
  font-size: 1.125rem;
}

.font22 {
  font-size: 1.375rem;
}

.color-red {
  color: #ff0000;
}

.flex {
  display: flex;
}

.between {
  justify-content: space-between;
}

.width100pre {
  width: 100%;
}

.address-wrap {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* .copy {
} */
.center-ver {
  align-items: center;
}

.center-hor {
  justify-content: center;
}

.line1 {
  line-height: 1.1;
}

.fixed {
  position: fixed;
}

.btn-wrap {
  bottom: 0;
  width: 100vw;
}

.btn-wrap>.left,
.right {
  width: 50vw;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.btn-wrap>.left {
  background: var(--btnColor);
}

.btn-wrap>.right {
  background-color: #dc1323;
}
</style>